export default "__VITE_ASSET__DF1T417w__"